import {
  LayoutDashboard,
  Building2,
  Database,
  FlaskConical,
  ListChecks,
  ShieldCheck,
  CircleDollarSign,
  Archive,
  Route as RouteIcon,
  Truck,
  BarChart3,
  ShieldAlert,
  type LucideIcon,
} from 'lucide-react';

export type NavChild = {
  id: string;
  label: string;
  href: string;
};

export type NavItem = {
  id: string;
  label: string;
  icon: LucideIcon;
  href?: string;
  children?: NavChild[];
};

export function buildMenu(
  mostrarInd: boolean,
  temAcessoModulo: (modulo: string) => boolean,
  isAdmin: boolean,
): NavItem[] {
  const items: NavItem[] = [];

  if (mostrarInd) {
    items.push({ id: 'empresas', label: 'Empresas', icon: Building2, href: '/empresas' });

    if (temAcessoModulo('dashboard')) {
      items.push({ id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, href: '/producao/dashboard' });
    }

    if (temAcessoModulo('produtos')) {
      items.push({
        id: 'cadastros',
        label: 'Cadastros',
        icon: Database,
        children: [
          { id: 'produtos', label: 'Produtos', href: '/producao/produtos' },
          { id: 'centro-trabalho', label: 'Centro de Trabalho', href: '/producao/centro-trabalho' },
          { id: 'responsaveis', label: 'Responsáveis', href: '/producao/responsaveis' },
          { id: 'veiculos', label: 'Veículos', href: '/producao/veiculos' },
          { id: 'unidades-medida', label: 'Unidades de Medida', href: '/producao/unidades-medida' },
        ],
      });
    }

    if (temAcessoModulo('fichas-tecnicas')) {
      items.push({
        id: 'engenharia',
        label: 'Engenharia',
        icon: FlaskConical,
        children: [
          { id: 'fichas-tecnicas', label: 'Fichas Técnicas', href: '/producao/fichas-tecnicas' },
          { id: 'roteiros', label: 'Roteiros', href: '/producao/roteiros' },
        ],
      });
    }

    if (temAcessoModulo('ordens')) {
      const children: NavChild[] = [
        { id: 'ordens', label: 'Ordens de Produção', href: '/producao/ordens' },
      ];
      if (temAcessoModulo('apontamentos')) {
        children.push({ id: 'apontamentos', label: 'Apontamentos', href: '/producao/apontamentos' });
      }
      items.push({ id: 'pcp', label: 'PCP', icon: ListChecks, children });
    }

    if (temAcessoModulo('qualidade')) {
      items.push({ id: 'qualidade', label: 'Qualidade', icon: ShieldCheck, href: '/producao/qualidade' });
    }

    if (temAcessoModulo('custos')) {
      items.push({ id: 'custos', label: 'Custos', icon: CircleDollarSign, href: '/producao/custos' });
    }

    if (temAcessoModulo('estoque')) {
      items.push({
        id: 'estoque',
        label: 'Estoque',
        icon: Archive,
        children: [
          { id: 'locais', label: 'Locais de Armazenamento', href: '/producao/locais' },
          { id: 'lotes', label: 'Lotes', href: '/producao/estoque/lotes' },
          { id: 'movimentacoes', label: 'Movimentações', href: '/producao/estoque/movimentacoes' },
        ],
      });
    }

    items.push({ id: 'rastreabilidade', label: 'Rastreabilidade', icon: RouteIcon, href: '/producao/rastreabilidade' });

    if (temAcessoModulo('romaneios')) {
      items.push({ id: 'romaneios', label: 'Romaneios', icon: Truck, href: '/producao/romaneios' });
    }

    items.push({ id: 'relatorios', label: 'Relatórios', icon: BarChart3, href: '/producao/relatorios' });
  }

  if (isAdmin) {
    items.push({
      id: 'administracao',
      label: 'Administração',
      icon: ShieldAlert,
      children: [
        { id: 'admin-dashboard', label: 'Dashboard Admin', href: '/admin/dashboard' },
        { id: 'admin-empresas', label: 'Empresas', href: '/admin/empresas' },
        { id: 'admin-usuarios', label: 'Usuários', href: '/admin/usuarios' },
        { id: 'admin-sincronizacao', label: 'Logs de Sincronização', href: '/admin/sincronizacao-logs' },
        { id: 'admin-logs', label: 'Logs do Sistema', href: '/admin/logs' },
      ],
    });
  }

  return items;
}
